/**
  * WooCommerce main Js File
  */


/**
  * Call the functions when the document is ready
  */
$(document).ready(function() {
	init();
});


/**
  * Call the functions when the window is resized
  */
$(window).on('resize', () => {
});


/**
  * Setup the functions we want to call when the page loads.
  */
function init() {
	returnsPageInfo();
	productGallerySlider();
	customSingleProductNumberInput();
	addTitleToBillingField();
	wooFormFocus();
	archiveProductPage();
	miscFunctions();
	singleProductAddToCartScroll();
}


/**
 * Sticky add to cart button
 */
function singleProductAddToCartScroll() {

    let navbar = $('.woocommerce-single-product-hero .single_add_to_cart_button');
    let header = $('.header');
    let stickyElm = $('.product-sticky');

    if (navbar.length) {

        window.onscroll = function() {runScroll()};
        window.onload = function() {runScroll()};

        let sticky = navbar.offset().top;

        function runScroll() {
            if (window.pageYOffset >= sticky) {
                stickyElm.addClass('is-sticky');
                // $('.adventure-popout').addClass('navbar-active');
            } else {
                stickyElm.removeClass('is-sticky');
                // navbar.removeClass('sticky');
                // header.removeClass('is-invisible');
                // $('.adventure-popout').removeClass('navbar-active');
            }
        }
    }
}

/**
  * JS to run on the returns endpoint (/my-account/delivery-returns/)
  */
function returnsPageInfo() {

	$('.js-filter-delivery-tab').on('click', function(e){
		e.preventDefault();
		$('.js-filter-delivery-tab').removeClass('is-active');
		$(this).addClass('is-active');
		let target = $(this).data('filter');
		$('.woo-delivery-returns-section__delivery-block').hide();
		$('.woo-delivery-returns-section__delivery-block[data-id="'+ target +'"]').show();
	});

	
	$('.js-show-delivery-content').on('click', function(e){
		e.preventDefault();
		// $('.js-show-delivery-content').not($(this)).removeClass('is-active');
		$(this).toggleClass('is-active');
		// $('.woo-delivery-returns-section__content').not($(this).find('.woo-delivery-returns-section__content')).hide();
		$(this).parent().find('.woo-delivery-returns-section__content').toggle();
	});
}


function productGallerySlider() {

	$('.js-product-gallery-slider-mob').slick({
		dots: false,
		infinite: true,
		arrows: true,
		speed: 500,
		slidesToShow: 1,
		fade: false,
		rows: 0,
		autoplay: false,
	    mobileFirst: true,
	    draggable: false,
	    responsive: [
	        {
	        	breakpoint: 767,
	                settings: 'unslick'
	        }
	    ]
	});
}


function customSingleProductNumberInput() {
	$('form.cart .quantity input[type="number"]').wrap('<div class="input-quantity-control"></div>');
	$('.input-quantity-control').prepend('<span class="input-quantity-control__btn input-quantity-control__btn--decrease"><i class="uil uil-angle-down"></i></span>');
	$('.input-quantity-control').append('<span class="input-quantity-control__btn input-quantity-control__btn--increase"><i class="uil uil-angle-up"></i></span>');

	if ($('form.cart .quantity input[type="number"]').val() == 1) {
    	$('.input-quantity-control__btn--decrease').addClass('input-quantity-control__btn--disabled');
	}

	$('body').on('click', '.input-quantity-control__btn', function() {
	    var currentTotal = $(this).parent().find('input[type=number]').val();
        if ($(this).hasClass('input-quantity-control__btn--increase')) {
            currentTotal++;
            $(this).parent().find('input[type=number]').attr('value', currentTotal);
        	$('.input-quantity-control__btn--decrease').removeClass('input-quantity-control__btn--disabled');
        } else {
            if (currentTotal == 1 || currentTotal == '1') {
            	$('.input-quantity-control__btn--decrease').addClass('input-quantity-control__btn--disabled');
            } else {
	            currentTotal--;
	            $(this).parent().find('input[type=number]').attr('value', currentTotal);
            	$('.input-quantity-control__btn--decrease').removeClass('input-quantity-control__btn--disabled');
            }


        }
        $(this).parent().find('input[type=number]').trigger("change");
	});
}


function addTitleToBillingField() {
	// $('<h3 class="with-margin-top">Billing Information</h3>').insertBefore('.checkout-process #billing_company_field');

	$('.woo-dynamic-field-wrap #billing_state').val('');
    $('#billing_more_info').prepend('<option disabled selected value="null">Select an option</option>');


    $('.woocommerce-EditAccountForm fieldset legend').after('<span class="js-enable-password-edit"><i class="uil uil-edit-alt"></i></span>')
    $('.woocommerce-EditAccountForm fieldset legend').after('<span class="js-disable-password-edit"><i class="uil uil-multiply"></i></span>')
	
	$('body').on('click', '.js-enable-password-edit', function() {
		$(this).parent().find('.woocommerce-form-flex-wrap').slideDown();
		$(this).closest('fieldset').addClass('is-active');
    });

	$('body').on('click', '.js-disable-password-edit', function() {
		$(this).parent().find('.woocommerce-form-flex-wrap').slideUp();
		$(this).closest('fieldset').removeClass('is-active');
    });

    var accountFormTargets = $('.woocommerce-EditAccountForm .woocommerce-form-row .woocommerce-Input, .woocommerce-EditAccountForm .woocommerce-form-row .select');
    var accountFormTargets2 = $('.woocommerce-address-fields .form-row .input-text, .woocommerce-address-fields .form-row select');
    accountFormTargets.each(function(i,obj){
    	$(this).after('<span class="js-enable-field-edit"><i class="uil uil-edit-alt"></i></span>');
    	$(this).after('<span class="js-disable-field-edit"><i class="uil uil-multiply"></i></span>');
    });

    accountFormTargets2.each(function(i,obj){
    	$(this).parent().after('<span class="js-enable-field-edit"><i class="uil uil-edit-alt"></i></span>');
    	$(this).parent().after('<span class="js-disable-field-edit"><i class="uil uil-multiply"></i></span>');
    });

	$('body').on('click', '.js-enable-field-edit', function() {
		// $(this).closest('form').find('.is-active').addClass('is-changed');
		$(this).parent().addClass('is-active');
		$(this).parent().find('.woocommerce-Input').focus();
    });

	$('body').on('click', '.js-disable-field-edit', function() {
		// $(this).closest('form').find('.is-active').addClass('is-changed');
		$(this).parent().removeClass('is-active');
    });
}

function wooFormFocus() {
	
	// Form magic
	$(".woo-dynamic-field-wrap input:not([type=checkbox],[type=radio]), textarea").each(function(index, el) {
	    var value = $(el).val();
	    if (value != "") {
	    	$(this).closest('.woo-dynamic-field-wrap').addClass("forminator-is_active");
	    }
	});

    $(document).on('focus',".woo-dynamic-field-wrap input:not([type=checkbox],[type=radio]), textarea", function() {

	    $(this).closest('.woo-dynamic-field-wrap').addClass("forminator-is_active");
	    $(this).closest('.woo-dynamic-field-wrap').find('.frm_error').addClass('is-hidden');

    }).on('blur',".woo-dynamic-field-wrap input:not([type=checkbox],[type=radio]), textarea", function() {
	    var value = $(this).val();
	    if (value == "") {
	      $(this).closest('.woo-dynamic-field-wrap').removeClass("forminator-is_active");
	      $(this).closest('.woo-dynamic-field-wrap').find('.frm_error').removeClass('is-hidden');
	    }
    }).on('click',"input[type=checkbox],[type=radio]", function() {
    	$(this).closest('.woo-dynamic-field-wrap').toggleClass('forminator-is_active')
    });

	// Form magic
	$("select").each(function(index, el) {
	    var value = $(el).val();
	    if (value == null || value == '') {
	    } else {
	    	$(el).addClass("forminator-is_active");
	    }
	});

	$("select").each(function(index, el) {
	    $(el).change(function(){
		    var value = $(el).val();
		    if (value == null || value == '') {
		    	$(el).removeClass("forminator-is_active");
		    } else {
		    	$(el).addClass("forminator-is_active");
		    }
	    });
	});
}


function archiveProductPage() {
	$('.js-show-mob-archive-filters').on('click', function(){
		$(this).toggleClass('is-active');
		$('.shop-archive__mob-filters-list').toggle();
	});
}

function miscFunctions() {
	$('.stars a').on('click', function(i, obj){
		$('.stars a').removeClass('is-filled');
		$(this).prevAll().addClass('is-filled');
	})


	$('.js-more-info-on-billing select').on('change', function() {
		var val = this.value;
		if (val == 'flgs' || val == 'other') {
			$('.js-more-info-on-billing-textarea').removeClass('is-hidden');
		} else {
			$('.js-more-info-on-billing-textarea').addClass('is-hidden');
		}
	});
}